import Svg, { Path } from 'react-native-svg'

export const MoreTabIcon = ({ height = 24, width = 24, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        fillOpacity={1}
        d="M4 7h16a1 1 0 1 0 0-2H4a1 1 0 0 0 0 2Zm16 10H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2Zm0-6H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2Z"
      />
    </Svg>
  )
}
